<template>
  <div>
    <section class="content">
      <div>
        <el-dialog title="Confirmar cambios" style="margin-top: -10vh; overflow: hidden" :visible.sync="showModalConfirmarDocumentacion" max-width="700px" width="80%" v-on:close="cerrarModalConfirmarDocumentacion()">
          <el-tabs type="card">
            <el-tab-pane :label="'Documentos aceptados (' + documentosAceptados.length + ')'">
              <el-table :data="documentosAceptados">
                <el-table-column label="Tipo de documento">
                  <template slot-scope="scope">
                    {{scope.row.document}}
                  </template>
                </el-table-column>
                <el-table-column property="date" label="Fecha"></el-table-column>
                <el-table-column label="Archivo">
                  <template slot-scope="scope">
                    <a :href="scope.row.url" target="_blank" style="padding-right: 20px">
                      <i class="fa fa-file-pdf-o"/> PDF
                    </a>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane :label="'Documentos rechazados (' + documentosRechazados.length + ')'">
              <el-table :data="documentosRechazados" style="max-height: calc(">
                <el-table-column label="Tipo de documento" width="130px">
                  <template slot-scope="scope">
                    {{scope.row.document}}
                  </template>
                </el-table-column>
                <el-table-column property="emisionDate" label="Fecha de emisión" width="200px"></el-table-column>
                <el-table-column label="Archivo" width="90px">
                  <template slot-scope="scope">
                    <a :href="scope.row.url" target="_blank" style="padding-right: 20px">
                      <i class="fa fa-file-pdf-o"/> PDF
                    </a>
                  </template>
                </el-table-column>
                <el-table-column label="Mensaje" :span="12">
                  <template slot-scope="scope">
                    <el-input type="textarea" resize="none" :rows="3" v-model="scope.row.mensajeRechazo"></el-input>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>

          <span slot="footer" class="dialog-footer">
            <button class="btn" v-on:click="cerrarModalConfirmarDocumentacion()">
              Cancelar
            </button>
            <button class="btn btn-primary" v-on:click="confirmarDocumentos()">
              Guardar
            </button>
          </span>
        </el-dialog>
        <el-dialog title="Documentación" :visible.sync="showModalDocumentation" width="70%" :lock-scroll="true" v-on:close="showModalDocumentation = false">
          <div class="col-md-12" style="margin-bottom: 10px" v-if="!user.isProvider">
            <div class="col-md-3">
              <label>Compañia</label>
            </div>
            <div class="col-md-9">
              <el-select v-model="idCompany" filterable placeholder="Seleccione Compania">
                  <el-option
                    v-for="item in providers"
                    :key="item.idCompany"
                    :label="item.companyName"
                    :value="item.idCompany">
                  </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-12" style="margin-bottom: 10px">
            <div class="col-md-3">
              <label>Fecha de emisión</label>
            </div>
            <div class="col-md-9">
              <el-date-picker
                v-model="emisionDate"
                type="date"
                value-format = "yyyy/MM/dd"
                placeholder="Fecha de emisión">
              </el-date-picker>
            </div>
          </div>
          <div class="col-md-12" style="margin-bottom: 10px">
            <div class="col-md-3">
              <label>Tipo de documento</label>
            </div>
            <div class="col-md-9">
              <el-select v-model="idDocument" placeholder="Tipo de documento">
                <el-option
                  v-for="item in documentType"
                  :key="item.idDocument"
                  :label="item.documentName"
                  :value="item.idDocument">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-md-12">
            <div class="col-md-3">
              <label>PDF</label>
            </div>
            <div class="col-md-9">
              <input type="file" accept="application/pdf" ref="fileDocument" style="width:80%; float: left;">
            </div>
          </div>
          <span slot="footer" class="dialog-footer">
            <button class="btn" v-on:click="showModalDocumentation = false, resetModal()">
              Cancelar
            </button>
            <button class="btn btn-primary" v-on:click="uploadDocumentation()"><!-- Hay que crear la funcion -->
              Enviar
            </button>
          </span>
        </el-dialog>
      </div>
      <div class="row" v-if="providerDocumentStatus">
        <div class="col-md-12 col-lg-12">
          <div class="box box-info">
            <div class="box-body">
              <table class="table table-striped">
                <thead>
                  <tr style="'font-size: 15px; text-align:center;">
                    <th :style="'text-align: center; vertical-align: middle;width: ' + (100 / providerDocumentStatus.length) + '%'" v-for="(item, index) in providerDocumentStatus">{{item.description}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr style="font-size: 25px; text-align:center" >
                    <td  class="statusHover" v-for="(item, index) in providerDocumentStatus" v-on:click="searchStatus(item.idProviderDocumentStatus)">{{getCountByStatus(item.idProviderDocumentStatus)}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-center" v-if="response" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{response}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
      <div class="box-body">
        <div style="margin-bottom: 10px">
          <el-row>
            <el-col :span="6">
              <!--
                <el-input type="text" placeholder="Nic" clearable v-model="filters[2].value">
                </el-input>
              -->
              <el-button style="background-color : #bf0532; color : #ffffff" @click="showModalDocumentation = true">
                  Subir Documentación
              </el-button>
            </el-col>
            <el-col :span="6">
              <el-select multiple v-model="filters[0].value" placeholder="Estado">
                <el-option
                  v-for="item in providerDocumentStatus"
                  :key="item.idProviderDocumentStatus"                  
                  :value="item.idProviderDocumentStatus"
                  :label="item.description">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-date-picker
              v-model="filters[1].value"
              type="daterange"
              range-separator="A"
              start-placeholder="Desde"
              end-placeholder="Hasta"
              unlink-panels>
              </el-date-picker>
            </el-col>
          </el-row>
        </div>
        <data-tables :data="documents" class="table-responsive" :pagination-props="{ pageSizes: [10, 20, 30] }" :filters="filters">
          <el-table-column label="Compañia" :align="'center'" v-if="!user.isProvider">
            <template slot-scope="scope">
              {{ scope.row.companyName }}
            </template>
          </el-table-column>
           <el-table-column label="CUIT" :align="'center'" v-if="!user.isProvider">
            <template slot-scope="scope">
              {{ scope.row.cuit }}
            </template>
          </el-table-column>
          <el-table-column label="Fecha de alta" :align="'center'">
            <template slot-scope="scope">
              {{ scope.row.date }}
            </template>
          </el-table-column>
         <el-table-column label="Fecha de emisión" :align="'center'">
            <template slot-scope="scope">
              {{ scope.row.emisionDate }}
            </template>
          </el-table-column>
         <el-table-column label="Estado" :align="'center'">
            <template slot-scope="scope">
              {{ scope.row.status }}
            </template>
          </el-table-column>
          <el-table-column label="Tipo de documento" :align="'center'">
            <template slot-scope="scope">
              {{ scope.row.document }}
            </template>
          </el-table-column>
          <el-table-column label="Justificacion Rechazo" :align="'center'">
            <template slot-scope="scope">
              <a style="cursor: pointer;" @click="mostrarMensajeCompleto(scope.row.mensajeRechazo)">
                {{ scope.row.mensajeRechazo }}
              </a>
            </template>
          </el-table-column>
          <el-table-column label="Documento" :align="'center'">
            <template slot-scope="scope">
              <a :href="scope.row.url" target="_blank">
                <el-button circle type="primary" icon="el-icon-document"></el-button>
              </a>
            </template>
          </el-table-column>
          <el-table-column label="Aceptar" fixed="right" align="center" v-if="!user.isProvider && documents.some(el => el.status === 'Enviado')">
            <template slot="header" slot-scope="scope"> <!-- NO USAR ESTE SCOPE PARA NADA DE NADA -->
              <el-button  size="mini" :disabled="documentosAceptados.length === 0 && documentosRechazados.length === 0" type="primary" @click="abrirModalConfirmacion()">
                Aceptar
              </el-button>
            </template>
            <template slot-scope="scope" v-if="scope.row.status === 'Enviado'">
              <el-button-group>
                <el-button  size="mini" :type="(documentosAceptados.includes(scope.row)) ? 'success' : ''" @click="handleIncluirDocumento(scope.row, 1)">
                  Si
                </el-button>
                <el-button  size="mini" :type="(documentosRechazados.includes(scope.row)) ? 'danger' : ''" @click="handleIncluirDocumento(scope.row, 2)">
                  No
                </el-button>
              </el-button-group>
            </template>
          </el-table-column>
        </data-tables>
      </div>
    </section>
  </div>
</template>
<script>
  require('moment')
  // Require needed datatables modules
  import datepicker from 'vue-date-picker'
  // import api from '../../api'
  import MaskedInput from 'vue-text-mask'
import { mapState } from 'vuex'
import api from '../../api'
  export default {
    name: 'Search',
    components: {
      datepicker,
      MaskedInput
    },
    data (router) {
      return {
        idCompany: '',
        documentosAceptados: [],
        documentosRechazados: [],
        providerDocumentStatus: [],
        emisionDate: '',
        idDocument: '',
        documentType: [],
        showModalDocumentation: false,
        showModalConfirmarDocumentacion: false,
        section: 'Search',
        loading: '',
        tipoFecha: 'emision',
        estado: '',
        response: '',
        desde: '',
        hasta: '',
        cliente: '',
        referencia: '',
        fecha: '',
        facturas: this.$store.state.facturas,
        clients: [],
        receptor: '',
        idUser: this.$store.state.user.idUser,
        filtrados: [],
        table: '',
        vue: this,
        rutMask: this.$store.state.rutMask,
        invoiceMask: this.$store.state.invoiceMask,
        titles: [{                      // Columnas que se van a mostrar
          prop: 'idCompany',
          label: 'Proveedor',
          forProvider: false
        },
        {
          prop: 'fecha_liberacion',
          label: 'Fecha',
          forProvider: true
        }],
        filters: [{
          prop: 'idProviderDocumentStatus',
          value: ''
        },
        {
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              if (prop === 'emisionDate') {
                if (filter.value !== null) {
                  return (new Date(row.emisionDate).getTime() <= filter.value[1].getTime() && new Date(row.emisionDate).getTime() >= filter.value[0].getTime())
                } else {
                  return true
                }
              }
            })
          },
          prop: ['emisionDate'],
          value: ''
        },
        {
          prop: 'nic',
          value: ''
        }],
        providers: []
      }
    },
    computed: {
      ...mapState([
        'user'
      ]),
      otherOperations () {
        return this.$store.state.otherOperations.sort(this.compareViewNics)
      },
      statusList () {
        let status = this.$store.state.countStatus.filter(el => el.statusId === '4' || el.statusId === '5' || el.statusId === '8')
        return status
      },
      datetime () {
        return new Date()
      },
      documents () {
        return this.$store.state.documents
      }
    },
    beforeRouteUpdate (to, from, next) {
      if (to === from) {
        this.filters[0].value = from.params.statusId
      }
      next()
    },
    mounted () {
      if (this.$route.params.statusId) {
        this.filters[0].value = this.$route.params.statusId
      }
    },
    beforeMount () {
      this.getProviders()
      this.getDocumentType()
      this.getDocuments()
      this.getProviderDocumentStatus()
    },
    methods: {
      getProviders () {
        this.$store.commit('START_LOADING')
        api.request('GET', 'api/generic/company?select=idCompany,companyName')
        .then(response => {
          this.providers = response.data
          this.$store.commit('STOP_LOADING')
        })
        .catch(error => {
          console.log(error)
          this.$store.commit('STOP_LOADING')
        })
      },
      cambiarEstadoDocumentos (documentos, statusId) {
        documentos.forEach(doc => {
          this.cambiarEstadoDocumento(doc, statusId)
        })
      },
      cambiarEstadoDocumento (documento, estado) {
        documento.idProviderDocumentStatus = estado.toString()
        api.request('POST', 'api/generic/providerDocument/' + documento.idProviderDocument, JSON.stringify(documento))
        .then(response => {
          /* if (estado === 2) {
            api.request('GET', 'api/sendMailAcceptedDocument/' + documento.idCompany)
          }
          if (estado === 3) {
            api.request('GET', 'api/sendMailRejectedDocument/' + documento.idCompany)
          } */
        })
      },
      confirmarDocumentos () {
        this.cambiarEstadoDocumentos(this.documentosRechazados, 3)
        this.cambiarEstadoDocumentos(this.documentosAceptados, 2)
        this.documentosAceptados = []
        this.documentosRechazados = []
        this.cerrarModalConfirmarDocumentacion()
      },
      cerrarModalConfirmarDocumentacion () {
        this.showModalConfirmarDocumentacion = false
        this.documentosRechazados.forEach(el => {
          el.mensajeRechazo = ''
        })
      },
      handleIncluirDocumento (row, status) {
        if (status === 1) {
          if (!this.documentosAceptados.includes(row)) {
            this.documentosRechazados = this.documentosRechazados.filter(el => el !== row)
            this.documentosAceptados.push(row)
          } else {
            this.documentosAceptados = this.documentosAceptados.filter(el => el !== row)
          }
        }
        if (status === 2) {
          if (!this.documentosRechazados.includes(row)) {
            this.documentosAceptados = this.documentosAceptados.filter(el => el !== row)
            this.documentosRechazados.push(row)
          } else {
            this.documentosRechazados = this.documentosRechazados.filter(el => el !== row)
          }
        }
      },
      resetModal () {
        this.idCompany = ''
        this.emisionDate = ''
        this.idDocument = ''
        const input = this.$refs.fileDocument
        input.type = 'text'
        input.type = 'file'
      },
      abrirModalConfirmacion () {
        this.showModalConfirmarDocumentacion = true
      },
      getDocumentType () {
        api.request('GET', 'api/generic/document')
        .then(response => {
          this.documentType = response.data
        })
      },
      getDocuments () {
        api.request('GET', 'api/getProviderDocuments/' + this.user.idUser)
        .then(response => {
          this.$store.commit('SET_DOCUMENTS', response.data)
        })
      },
      getProviderDocumentStatus () {
        api.request('GET', 'api/generic/providerDocumentStatus')
        .then(response => {
          this.providerDocumentStatus = response.data
          if (this.providerDocumentStatus[0].description === 'Enviado' && !this.user.isProvider) {
            this.providerDocumentStatus[0].description = 'Recibido'
          }
        })
      },
      createOperation () {
        api.request('POST', 'api/generic/buyOrder', JSON.stringify({'nic': null, 'idCompany': this.user.company.idCompany, 'fecha_liberacion': this.datetime, 'pdf': null, 'statusId': 4, 'view': 0}))
        .then(response => {
          this.goToDetails(response.data.idBuyOrder)
        })
      },
      mostrarMensajeCompleto (mensaje) {
        this.$alert(mensaje, 'Mensaje', {
          confirmButtonText: 'OK'
        })
      },
      uploadDocumentation () {
        this.$confirm('¿Realmente desea adjuntar este pdf a la documentacion?', 'Advertencia', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancelar',
          type: 'warning',
          lockScroll: false
        })
        .then(() => {
          if ((!this.user.isProvider && this.idCompany || this.user.isProvider) && this.idDocument && this.$refs.fileDocument.files[0] && this.emisionDate) {
            let formData = new FormData()
            formData.append('file', this.$refs.fileDocument.files[0])
            formData.append('folder', 'documentation')
            api.request('POST', 'api/uploadFile', formData)
            .then(response => {
              api.request('POST', 'api/generic/providerDocument', JSON.stringify({'url': response.data, 'idCompany': this.user.isProvider ? this.user.company.idCompany : this.idCompany, 'idDocument': this.idDocument, 'idProviderDocumentStatus': this.user.isProvider ? 1 : 2, 'emisionDate': this.emisionDate, 'date': new Date().getFullYear() + '-' + new Date().getMonth() + '-' + new Date().getDate()}))
              .then(response2 => {
                this.showModalDocumentation = false
                this.resetModal()
                this.getDocuments()
              })
            })
          } else {
            this.$message.warning('Falta completar los campos')
          }
        })
        .catch(() => {
        })
      },
      seeCreateOperationModal () {
        this.showModalCreateOperation = true
      },
      searchStatus (status) {
        this.filters[0].value = [status]
        // this.filterInvoices()
      },
      getStatusName (statusId) {
        return this.statusList.find(estado => estado.statusId === statusId).description
      },
      getCountByStatus (statusId) {
        return this.documents.filter(el => el.idProviderDocumentStatus === statusId).length
      },
      goToDetails (idBuyOrder) {
        this.$router.push('/invoicedetail?i=' + idBuyOrder)
      },
      toggleLoading () {
        this.loading = (this.loading === '') ? 'cargando' : ''
      },
      resetResponse () {
        this.response = ''
      },
      compareViewNics (a, b) {
        if (a.view < b.view) {
          return -1
        } else if (a.view > b.view) {
          return 1
        }
        /* else if (a.payment && b.payment && a.payment.visto < b.payment.visto) {
          return -1
        } else if (a.payment && b.payment && a.payment.visto > b.payment.visto) {
          return 1
        } */
        return 0
      },
      compareViewInvoice (a, b) {
        if (!a.factura) {
          return 1
        }
        if (!b.factura) {
          return -1
        }
        if (a.factura.visto < b.factura.visto) {
          return -1
        } else if (a.factura.visto > b.factura.visto) {
          return 1
        }
        return 0
      }
    }
  }
</script>
<style>
  .datetime-picker input {
    height: 4em !important;
  }

  /* Using the bootstrap style, but overriding the font to not draw in
   the Glyphicons Halflings font as an additional requirement for sorting icons.

   An alternative to the solution active below is to use the jquery style
   which uses images, but the color on the images does not match adminlte. */

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after {
  font-family: 'FontAwesome';
}

table.dataTable thead .sorting:after {
  content: "\f0dc";
}

table.dataTable thead .sorting_asc:after {
  content: "\f0dd";
}

table.dataTable thead .sorting_desc:after {
  content: "\f0de";
}
table.dataTable tr {
  cursor: pointer
}
.table {
  width: 100% !important;
}
.dataTables_length label, .dataTables_filter label{
  margin-bottom: 30px;
  position: static ;
  display:block;
  pointer-events: fill;
  z-index:3000;
}
.statusHover:hover {
  transition: background-color 0.5s ease;
  cursor: pointer;
  background-color:darkgray;
  color:black;
}

.filtro {
  margin-bottom: 10px;
}
.sorting::after, .sorting_asc:after, .sorting_desc:after {
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// SubmitDocumentation.vue?0e21a613